'use client';
const MARKETING_COLORS = {
    atlantic: '#16618c',
    black900: '#000000',
    caspian: '#204949',
    celtic: '#046240',
    darkGrey: '#5c5c5c',
    emerald: '#0a806b',
    graphite: '#313131',
    holiday: '#9a0202',
    holidayBeige1: '#ede3cf',
    holidayGreen1: '#50af60',
    holidayGreen2: '#06462E',
    holidayRed1: '#8b0d13',
    holidayRed2: '#8b0d13',
    kingfisher: '#017eb4',
    mediumGreen: '#318643',
    mediumGrey: '#dfdfdf',
    opal: '#c0e6df',
    platinum: 'efefef',
    rio: '#99d3f3',
    rum: '#c94b2f',
    talavera: '#2b3b55',
    warmWhite: '#f6f6ec',
    white: '#ffffff'
};
const BACKGROUND_WITH_MODE = {
    standard: {
        standardMode: !0,
        darkMode: !0
    },
    info: {
        standardMode: !0,
        darkMode: !0
    },
    strong: {
        standardMode: !0,
        darkMode: !0
    },
    accent: {
        standardMode: !0,
        darkMode: !0
    },
    promo: {
        standardMode: !0,
        darkMode: !0
    },
    help: {
        standardMode: !0,
        darkMode: !0
    },
    success: {
        standardMode: !0,
        darkMode: !0
    },
    warning: {
        standardMode: !0,
        darkMode: !0
    },
    error: {
        standardMode: !0,
        darkMode: !0
    },
    'warm-white': {
        standardMode: !0,
        darkMode: !1
    },
    midnight: {
        standardMode: !1,
        darkMode: !0
    },
    holiday: {
        standardMode: !1,
        darkMode: !0
    },
    'holiday-beige-1': {
        standardMode: !0,
        darkMode: !1
    },
    'holiday-green-1': {
        standardMode: !0,
        darkMode: !1
    },
    'holiday-green-2': {
        standardMode: !1,
        darkMode: !0
    },
    'holiday-red-1': {
        standardMode: !1,
        darkMode: !0
    },
    'holiday-red-2': {
        standardMode: !1,
        darkMode: !0
    },
    black: {
        standardMode: !1,
        darkMode: !0
    },
    transparent: {
        standardMode: !0,
        darkMode: !0
    }
};

export { BACKGROUND_WITH_MODE, MARKETING_COLORS };
